import { ProtocolInterface } from "../interfaces/Protocols.interface";

// eslint-disable-next-line import/prefer-default-export
export const BLANK_PROTOCOL: ProtocolInterface = {
	id: "",
	name: "",
	default_interface: {},
	cdo_interface: {},
};
